import {State, Module} from 'app/decorators';
import BaseRoute from 'app/routing';
import ProductInventoryStore from 'app/stores/productInventory';
import InventoryTransactionStore from 'app/stores/inventoryTransaction';
import NutrientPicker from 'app/directives/nutrient.picker';
import UiLocationPicker from 'app/directives/ui.location.picker';

import {ProductsCtrl, ProductCtrl, TransactionsCtrl} from './ctrls';
import mainTpl from './templates/main.html';
import detailsTpl from './templates/details.html';
import transactionsTpl from './templates/transactions.html';

import tableSectionTpl from './templates/table.section.html';
import detailSectionTpl from './templates/detail.section.html';


@Module({
    name: 'admin.company.inventory',
    modules: [
        BaseRoute, NutrientPicker, UiLocationPicker,
        ProductInventoryStore, InventoryTransactionStore
    ],
})
@State({
    name: 'r.in.top.admin.company.inventory',
    url: '/inventory',
    template: mainTpl,
    abstract: '.list',
    data: {
        permissions: {
            only: [
                'main.view_productinventory',
            ],
        },
    },
    ncyBreadcrumb: {
        skip: true,
        parent: 'r.in.top.admin.company',
    },
})
@State({
    name: 'r.in.top.admin.company.inventory.list',
    url: '?search',
    views: {
        tableView: {
            template: tableSectionTpl,
            controller: ProductsCtrl,
        },
        detailsView: {
            template: detailSectionTpl,
        },
    },
    ncyBreadcrumb: {
        label: 'Inventory',
    },
})
@State({
    name: 'r.in.top.admin.company.inventory.list.product',
    url: '/{objectId:int}',
    template: '<ui-view/>',
    abstract: '.detail',
    ncyBreadcrumb: {
        skip: true,
    },
    controller: function ($rootScope, $scope, $stateParams) {
        "ngInject";
        $rootScope.selectedObject = $stateParams.objectId;
        $scope.$on('$destroy', function(){
            delete $rootScope.selectedObject;
        })
    },
    resolve: {
        $object: function($stateParams, ProductInventoryStore) {
            return ProductInventoryStore.get($stateParams.objectId);
        },
    },
})
@State({
    name: 'r.in.top.admin.company.inventory.list.product.detail',
    url: '',
    controller: ProductCtrl,
    template: detailsTpl,
    ncyBreadcrumb: {
        label: '{{ vm.object.product.description }}',
    },
})
@State({
    name: 'r.in.top.admin.company.inventory.list.product.transactions',
    url: '/transactions',
    controller: TransactionsCtrl,
    template: transactionsTpl,
    ncyBreadcrumb: {
        label: '{{ vm.object.product.description }}',
    },
})
export default class States { }



// WEBPACK FOOTER //
// ./src/app/admin/inventory/routing.js